import { SectionTitle } from '@elotech/components';
import PropTypes from 'prop-types';
import React from 'react';

const Observacao = props => {
  const { observacao, onChangeField } = props;
  return (
    <div>
      <SectionTitle>Observações</SectionTitle>
      <div className="form-group">
        <label htmlFor="observacaoInput">Observação sobre o requerimento</label>
        <input
          id="observacaoInput"
          data-cy="inputObservacao"
          type="textarea"
          name="observacaoCidadao"
          maxLength={4096}
          value={observacao}
          onChange={onChangeField}
        />
        <div
          className="help-message gray-60 right col-md-12"
          data-testid="contador-textarea"
        >
          {`${(observacao || '').length}/4096`}
        </div>
      </div>
    </div>
  );
};

Observacao.propTypes = {
  observacao: PropTypes.string,
  onChangeField: PropTypes.func.isRequired
};

export default Observacao;
